module.exports = __webpack_public_path__ + "static/media/light-switch-on.c823c877.svg";